<i18n src="./resources/locales.json"></i18n>

<template>
  <v-card id="loading-wrapper" tile class="surface darken-1" :style="CSS_VARS">
    <div v-once id="loading-text">{{ $t('loadingText') }}</div>
    <div id="loading-content" />
    <div v-if="showLongLoadMessage" id="long-load-time-message">
      {{ $t('longLoadTimeMessage') }}
    </div>
  </v-card>
</template>

<script>
import ThemeUtility from '@/components/ecs-theme/ecs-theme-utility';

export default {
  name: 'EcsSplashScreen',

  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showLongLoadMessage: false,
      hardRefreshRef: null
    };
  },

  computed: {
    CSS_VARS() {
      return {
        '--outer-color': this.theme.primary,
        '--inner-color': this.theme.secondary,
        '--bg-color': this.theme.surface,
        '--info-color': this.theme.info,
        '--success-color': this.theme.success,
        '--error-color': this.theme.error
      };
    },
    theme() {
      return ThemeUtility.getTheme()[ThemeUtility.getThemeMode()];
    }
  },

  mounted() {
    this.showLongLoadMessage = false;

    setTimeout(() => {
      if (this.isLoading) {
        this.showLongLoadMessage = true;
      }
    }, 5000);

    this.hardRefreshRef = setTimeout(() => {
      location.reload();
    }, 60000);
  },

  beforeDestroy() {
    clearTimeout(this.hardRefreshRef);
  }
};
</script>

<style scoped>
#loading-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: linear-gradient(90deg, #001718 25%, #034c57 100%);
}

#loading-text {
  display: block;
  position: absolute;
  top: calc(50% - 35px);
  left: calc(50% - 50px);
  color: inherit;
  width: 100px;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
}

#long-load-time-message {
  display: block;
  position: absolute;
  top: calc(50% + 120px);
  left: calc(50% - 225px);
  color: inherit;
  width: 420px;
  text-align: center;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  opacity: 0.75;
}

#loading-content {
  display: block;
  position: relative;
  top: calc(50% - 100px);
  left: calc(50% - 100px);
  width: 200px;
  height: 200px;
  border: 3px solid transparent;
  border-top-color: var(--outer-color, #f47920);
  border-bottom-color: var(--outer-color, #f47920);
  border-radius: 50%;
  -webkit-animation: loader 2s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
  animation: loader 2s linear infinite;
}

#loading-content:after {
  content: '';
  position: absolute;
  border: 3px solid var(--success-color, #fff);
  left: 15px;
  right: 15px;
  top: 15px;
  bottom: 15px;
}

#loading-content:before {
  content: '';
  position: absolute;
  border: 3px solid var(--info-color, #fff);
  left: 5px;
  right: 5px;
  top: 5px;
  bottom: 5px;
}

#loading-content:before {
  border: 3px solid transparent;
  border-top-color: white;
  border-bottom-color: white;
  border-radius: 50%;
  -webkit-animation: loader 3s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
  animation: loader 3s linear infinite;
}

#loading-content:after {
  border: 3px solid transparent;
  border-top-color: var(--inner-color, --v-xtium-robin-egg-blue);
  border-bottom-color: var(--inner-color, --v-xtium-robin-egg-blue);
  border-radius: 50%;
  -webkit-animation: loader 1.5s linear infinite;
  animation: loader 1.5s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
}

@keyframes loader {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loaders {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loaders {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
